// components/DealPipeline/DealPipeline.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
const DealPipeline: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6">
            <div className="max-w-7xl mx-auto">
                <PipelineHeader />
                <ComingSoonSection />
            </div>
        </div>
    );
};

const PipelineHeader: React.FC = () => {
    return (
        <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2"><span className='text-green-800'>₦</span> Deals</h1>
            <p className="text-gray-600">Track your sales pipeline</p>
        </div>
    );
};


const ComingSoonSection: React.FC = () => {
    const navigate = useNavigate()
    const handleReturnToDashboard = () => {
        navigate('/crm/dashboard')
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 md:p-8 lg:p-12">
            <div className="text-center max-w-2xl mx-auto">
                <div className="mb-6">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                        <span className='text-green-500 text-2xl'>₦</span>
                    </div>
                    <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-2">
                        Deal Pipeline Coming Soon
                    </h2>
                    <p className="text-gray-600 mb-6">
                        Continue prompting to add the full deal pipeline with stages, forecasting, and analytics.
                    </p>
                </div>

                <button
                    onClick={handleReturnToDashboard}
                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                >
                    Return to Dashboard
                </button>
            </div>
        </div>
    );
};


const Deals: React.FC = () => {
    return <DealPipeline />;
};

export default Deals;